<template>
  <Component
    :is="maxSmall ? Drawer : Popover"
    v-bind="maxSmall ? { title, description, background: 'white' } : { align }"
  >
    <slot />
    <template #content>
      <slot name="content" />
    </template>
  </Component>
</template>

<script setup>
import { Drawer } from "@/SharedComponents/Drawer";
import { Popover } from "@/SharedComponents/Popover";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineProps({
  title: { type: String, required: false },
  description: { type: String, required: false },
  align: { type: String, required: false },
});
</script>
